import React from "react";
import bannerImg from "../../Assets/Cow-packages-banner.png";
import "./GalleryStaticBanner.css";

const GalleryStaticBanner = () => {
  return (
    <section className="gallery-vf-wrapper">
      <div className="gallery-vf-bg"></div>

      <div className="gallery-vf-content-wrapper">
        
        {/* Left Text */}
        <div className="gallery-vf-text anim anim-top">
  <h1>Our Modern Infrastructure</h1>
<p>
  Explore the advanced infrastructure of Vangal Dairies, equipped with modern
  machinery, hygienic production units, and a robust cold chain system.
  Our state-of-the-art facilities ensure superior quality, freshness, and
  purity in every dairy product we deliver.
</p>
</div>
        {/* Right Image */}
        <div className="gallery-vf-image anim anim-bottom">
          <img src={bannerImg} alt="cow" />
        </div>
      </div>
    </section>
  );
};

export default GalleryStaticBanner;
